import React from 'react';
import cx from 'classnames';
import { useSiteMap } from '@unisporkal/sites';
import { RawHtml } from '@unisporkal/utilities';
import { useTheme } from '@unisporkal/themes';
import { useTranslations } from '@unisporkal/localization';
import MiniDownloadHistory from '../../MiniDownloadHistory/MiniDownloadHistory';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import styles from './RestrictedForm.module.scss';

const RestrictedForm = () => {
  const t = useTranslations();
  const siteMap = useSiteMap();
  const theme = useTheme();
  const themeLink = theme.link || {};
  const { asset } = useAsset();

  const isRmImage = () => asset.isRightsManaged() && asset.isImage();

  const showImageRestrictionText = () =>
    isRmImage() && asset.showTestGeoLocRestriction;

  const filmLicenseVerbiage = () =>
    t('unable_to_license_clip_online', {
      links: [
        {
          href: siteMap.pathRef('contact'),
          target: 'contact_us',
        },
      ],
    });

  const imageLicenseVerbiage = () => {
    if (asset.isCreative() && asset.isRightsManaged()) {
      return t('unable_to_licence_creative_rm');
    }
    return t('unable_to_license_image_online', {
      links: [
        {
          href: siteMap.pathRef('contact'),
          target: 'contact_us',
        },
      ],
    });
  };

  const restrictedVerbiage = () => {
    let verbiage = '';
    if (asset.isBlocked || showImageRestrictionText()) {
      verbiage = asset.isFilm()
        ? filmLicenseVerbiage()
        : imageLicenseVerbiage();
    } else if (asset.hidden) {
      verbiage = t('unable_to_license_media', { assetid: asset.id });
    }
    return verbiage;
  };

  const onlineAsset = () => (
    <div data-testid="restricted-form-online-asset">
      <div
        data-testid="standard-restricted-asset-text"
        className={cx(styles.restrictedAssetMessageItem, themeLink.textLink)}
      >
        <RawHtml>{restrictedVerbiage()}</RawHtml>
      </div>
      <MiniDownloadHistory />
    </div>
  );

  const offlineAsset = () => (
    <div data-testid="restricted-form-offline-asset">
      <div className={styles.restrictedAssetMessageItem}>
        {t('analog_archive_message_title')}
      </div>
      <div
        className={cx(styles.restrictedAssetMessageItem, themeLink.textLink)}
      >
        <RawHtml>
          {t('analog_archive_message_contact', {
            links: [
              { href: siteMap.pathRef('contact'), target: 'contact_us' },
              { href: `/purchase/request-preview/${asset.id}` },
            ],
          })}
        </RawHtml>
      </div>
      <MiniDownloadHistory />
    </div>
  );

  return (
    <section
      className={styles.restrictedAsset}
      data-testid="restricted-form"
    >
      {asset.isOffline ? offlineAsset() : onlineAsset()}
    </section>
  );
};

export default RestrictedForm;
